import React from "react";

import { Table, Typography } from "antd";

const { Text, Title } = Typography;

const Tasks = (props) => {
    const expandedRowRender = (record) => {
        let baseUnit = record.baseUnit ? record.baseUnit.name : " ";

        const receivables = record.receivables.filter((e) => e.subtotalValue > 0 || e.rectification);

        const columns = (props, unit) => {
            return [
                {
                    title: "Description",
                    dataIndex: "catlogValue",
                    key: "type",
                    idth: 50,
                    render: (catlogValue, record) => {
                        if (catlogValue) {
                            return catlogValue.name;
                        }

                        if (record.rectification) {
                            return record.concept ? record.concept : "Rectification";
                        }

                        return unit;
                    },
                },
                {
                    title: "#",
                    dataIndex: "count",
                    key: "count",
                    align: "right",
                    width: 50,
                    render: (count, record) => (record.percent ? Number.parseInt(count) : count),
                },
                {
                    title: "Rate",
                    dataIndex: "rateValue",
                    key: "rateValue",
                    align: "right",
                    width: 150,
                    render: (rateValue, record) => (record.percent ? `${rateValue} (${record.percent}%)` : rateValue),
                },
                {
                    title: "Subtotal",
                    dataIndex: "subtotalValue",
                    key: "subtotalValue",
                    align: "right",
                    width: 150,
                },
            ];
        };

        return (
            <Table
                columns={columns(props, baseUnit)}
                rowKey={(record) => record.id}
                dataSource={receivables || []}
                pagination={false}
            />
        );
    };
    const columns = (props) => {
        const __columns = [
            { title: "#", dataIndex: "code", key: "order", width: 50 },
            { title: "Service", dataIndex: "name", key: "name" },
            {
                title: "Category",
                dataIndex: "serviceCategory",
                key: "category",
                render: (category, record) => {
                    if (category) {
                        return <>{category?.name}</>;
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Language(s)",
                dataIndex: "languageType",
                key: "languageType",
                render: (type, record) => {
                    if (type == "Single") {
                        if (record.languageFamily == "LTR" || record.languageFamily == "RTL") {
                            return <>{record.languageFamily}</>;
                        }
                        return <>{record.language?.code}</>;
                    } else {
                        return <>{record.languagePair?.code}</>;
                    }
                },
            },
            {
                title: "Unit",
                dataIndex: "baseUnit",
                key: "unit",
                render: (unit, record) => {
                    if (unit) {
                        if (record.isWord) {
                            return <>{record.effectiveWordCount} WC</>;
                        } else {
                            return (
                                <>
                                    {record.baseUnitAmount} {unit.name}
                                </>
                            );
                        }
                    }
                },
            },
        ];

        __columns.push({
            title: "Rush",
            dataIndex: "rushType",
            key: "rushType",
            align: "center",
            width: 150,
            render: (rushType, record) => <>{parseFloat(record.rushClientPercent).toFixed(0) + "%"}</>,
        });

        __columns.push({
            title: "Price",
            dataIndex: "totalToReceiveValue",
            key: "totalToReceiveValue",
            width: 200,
            align: "right",
            render: (price, record) => (
                <>
                    {price} {record.totalToReceiveType}
                </>
            ),
        });

        return __columns;
    };

    const totalRectificationAmount = () => {
        let stotal = 0.0;
        (props.receivables || []).forEach(({ subtotalValue }) => {
            stotal = parseFloat(subtotalValue).toFixed(4) + stotal;
        });

        return parseFloat(stotal).toFixed(4);
    };

    const rectificationTask = {
        id: "rec",
        name: "Rectification",
        isWord: false,
        baseUnit: {
            name: "-",
        },
        rushClientPercent: 0,
        totalToReceiveValue: totalRectificationAmount(),
        totalToReceiveType: props.job.totalToReceiveType,
        receivables: props.receivables,
    };

    const tasks = (props.receivables || []).length > 0 ? props.tasks.concat([rectificationTask]) : props.tasks;

    const uncompensatedAmount = Number.parseFloat(props.job.totalToReceiveValue - props.job.balanceClient).toFixed(4);
    const uncompensatedStatus =
        uncompensatedAmount > 0.00001 ? "success" : uncompensatedAmount < -0.00001 ? "danger" : "";

    return (
        <>
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                expandable={{
                    expandedRowRender,
                    rowExpandable: (record) => true,
                    expandedRowClassName: (record, index, indent) => "table-finance-details",
                }}
                rowKey={(record) => record.id}
                dataSource={tasks}
                pagination={false}
                ooter={() => `${props.job.totalToReceiveValue} ${props.job.totalToReceiveType}`}
                title={() => <Title level={5}>Receivables</Title>}
                summary={(pageData) => {
                    let subtotal = 0.0;

                    pageData.forEach(({ totalToReceiveValue }) => {
                        subtotal += parseFloat(totalToReceiveValue).toFixed(4);
                    });

                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell colSpan={6}></Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text strong>Total</Text>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text strong>
                                        {props.job.totalToReceiveValue} {props.job.totalToReceiveType}
                                    </Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                            <Table.Summary.Row>
                                <Table.Summary.Cell colSpan={6}></Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text strong>Invoiced</Text>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text type="danger">
                                        ({props.job.balanceClient} {props.job.totalToReceiveType})
                                    </Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                            <Table.Summary.Row>
                                <Table.Summary.Cell colSpan={6}></Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text strong>Uncompensated</Text>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text type={uncompensatedStatus}>
                                        {uncompensatedAmount} {props.job.totalToReceiveType}
                                    </Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
            />
        </>
    );
};

export default Tasks;
